import script from "./QuizQuestionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizQuestionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuizQuestionsPage.vue?vue&type=style&index=0&id=6ac6d704&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac6d704"]])

export default __exports__